import { createAsyncThunk } from "@reduxjs/toolkit";

import { EquipmentResponse } from "../../api/generated";
import { Api } from "../../api";

export const getAllEquipment = createAsyncThunk("getAllEquipment", async (): Promise<EquipmentResponse[]> => {
  return Api.Equipment.getAllEquipment().then(({ data }) => {
    return data;
  });
});
